// Shared by draft routes and applied routes on Smart Map.
export const routeColor = (color?: string) => color || "#e11d48";

export function makeDepotIcon(kind: "start" | "end", color: string): google.maps.Symbol {
  return {
    path: kind === "start" ? google.maps.SymbolPath.BACKWARD_CLOSED_ARROW : google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
    fillColor: color, fillOpacity: 1, strokeColor: "#333", strokeWeight: 1, scale: 6,
  };
}

export function makeStopIcon(color: string): google.maps.Icon {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24">
    <path d="M12 2c-3.866 0-7 3.134-7 7 0 5.25 7 13 7 13s7-7.75 7-13c0-3.866-3.134-7-7-7z"
      fill="${color}" stroke="#333" stroke-width="1.2"/>
    <circle cx="12" cy="9.8" r="3.4" fill="${color}" /></svg>`;
  return { url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svg),
    scaledSize: new google.maps.Size(36, 36), anchor: new google.maps.Point(18, 34), labelOrigin: new google.maps.Point(18, 14.7) };
}
